export const colors = {
  tealLight: '#32e0c4',
  tealDark: '#2cc9b0',
  tealDeep: '#25b09a',
  gold: '#f3c623',
  goldDark: '#dbb31f',
  darkBg: '#222831',
  darkBgLight: '#393e46',
  light: '#eeeeee',
  shadow: '#171b21',
}

export const darkTheme = {
  mode: 'dark',
  bg: colors.darkBg,
  bgAlt: colors.darkBgLight,
  text: colors.light,
  textMuted: '#aaaaaa',
  accent: colors.tealDark,
  accentLight: colors.tealLight,
  accentDeep: colors.tealDeep,
  gold: colors.gold,
  goldDark: colors.goldDark,
  shadow: colors.shadow,
  heroText: colors.darkBg,
  heroBg: colors.light,
  cardBg: colors.darkBgLight,
  cardBgHover: '#424852',
  cardHighlight: 'rgba(243,198,35,0.25)',
  cardHighlightHover: 'rgba(243,198,35,0.33)',
  linkHoverShadow: 'rgba(243,198,35, 0.5)',
  accentHoverShadow: 'rgba(44,201,176, 0.5)',
  glassBg: 'rgba(57, 62, 70, 0.4)',
  glassBorder: 'rgba(255,255,255,0.1)',
  navBg: 'rgba(34, 40, 49, 0.85)',
}

export const lightTheme = {
  mode: 'light',
  bg: '#f5f5f5',
  bgAlt: '#e0e0e0',
  text: '#222831',
  textMuted: '#555555',
  accent: colors.tealDark,
  accentLight: colors.tealLight,
  accentDeep: colors.tealDeep,
  gold: '#c9a200',
  goldDark: '#b08e00',
  shadow: 'rgba(0,0,0,0.12)',
  heroText: '#222831',
  heroBg: '#ffffff',
  cardBg: '#ffffff',
  cardBgHover: '#f0f0f0',
  cardHighlight: 'rgba(44,201,176,0.15)',
  cardHighlightHover: 'rgba(44,201,176,0.25)',
  linkHoverShadow: 'rgba(44,201,176, 0.4)',
  accentHoverShadow: 'rgba(44,201,176, 0.5)',
  glassBg: 'rgba(255, 255, 255, 0.6)',
  glassBorder: 'rgba(0,0,0,0.1)',
  navBg: 'rgba(245, 245, 245, 0.85)',
}
